var React = require('react');

function MenuInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"Path_1","data-name":"Path 1","d":"M58.331,127.74H2.536a2.536,2.536,0,0,1,0-5.072H58.331a2.536,2.536,0,0,1,0,5.072Zm0,0","transform":"translate(0 -103.224)","key":0}),React.createElement("path",{"id":"Path_2","data-name":"Path 2","d":"M58.331,5.072H2.536A2.536,2.536,0,0,1,2.536,0H58.331a2.536,2.536,0,0,1,0,5.072Zm0,0","key":1}),React.createElement("path",{"id":"Path_3","data-name":"Path 3","d":"M58.331,250.4H2.536a2.536,2.536,0,1,1,0-5.072H58.331a2.536,2.536,0,1,1,0,5.072Zm0,0","transform":"translate(0 -206.445)","key":2})]);
}

MenuInline.defaultProps = {"id":"open-menu","width":"60.867","height":"43.959","viewBox":"0 0 60.867 43.959"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
